<template>
  <v-app class="tw-gray-100">
    <default-header left-clip />
    <v-main class="tw-min-h-screen">
      <app-drawer-main />
      <slot>
        <v-fade-transition>
          <router-view/>
        </v-fade-transition>
      </slot>
      <default-footer />
    </v-main>
  </v-app>
</template>

<script>
import DefaultHeader from '@/components/layouts/DefaultHeader'
import DefaultFooter from '@/components/layouts/DefaultFooter'
import AppDrawerMain from '@/components/layouts/AppDrawerMain'
export default {
  name: 'AppLayout',
  components: { AppDrawerMain, DefaultFooter, DefaultHeader }
}
</script>

<style scoped>

</style>
